import React from 'react';
import { s as systemConfig } from './system.config-53082f30.js';
import { Modal, Button } from 'quanta-ui';

function ModalTransactionLock(_ref) {
  var showTransactionLockModal = _ref.showTransactionLockModal,
      setShowTransactionLockModal = _ref.setShowTransactionLockModal;

  var closeModal = function closeModal() {
    setShowTransactionLockModal(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: showTransactionLockModal,
    title: "Restricted Access",
    onClose: function onClose(_) {
      return closeModal();
    },
    severity: 'info'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-warning p-2 text-white rounded mb-2"
  }, /*#__PURE__*/React.createElement("b", null, "WARNING "), systemConfig === null || systemConfig === void 0 ? void 0 : systemConfig.transactionLockText), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: function onClick() {
      return closeModal();
    },
    className: "max-w-36"
  }, "Ok, I understand")));
}

export { ModalTransactionLock as M };
